/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notfound_Code1Inputs */

const he_notfound_code1 = /** @type {(inputs: Notfound_Code1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`404`)
};

const en_notfound_code1 = /** @type {(inputs: Notfound_Code1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`404`)
};

/**
* | output |
* | --- |
* | "404" |
*
* @param {Notfound_Code1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const notfound_code1 = /** @type {((inputs?: Notfound_Code1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notfound_Code1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_notfound_code1(inputs)
	return en_notfound_code1(inputs)
});
export { notfound_code1 as "notFound_code" }